
let loop = setInterval(() => {
    const teBox = document.querySelector(".bss-b2b-tax-ex-wrapper")
    const ajaxSubtotal = document.querySelector("#AjaxCartSubtotal");
    if(teBox && ajaxSubtotal) {
        ajaxSubtotal.insertAdjacentElement("afterBegin", teBox);
        clearInterval(loop);
    }
}, 100);

setTimeout(() => {
    clearInterval(loop);
}, 5000);
